import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from "react-router-dom";

import TextField from '@material-ui/core/TextField';
import Pagination from '@material-ui/lab/Pagination';
import CircularProgress from '@material-ui/core/CircularProgress';

import { AuthUserContext, withAuthorization } from '../../contexts/Session';
import Header from '../../components/Header/Admin/index';
import ProfilesButton from '../../components/Button/index';
import searchButton from '../../assets/Icons/searchButton.svg';
import Card from '../../components/Cards/Profiles/index';
import ModalPJ from '../../components/Modal/Admin/PJ/index';
import ModalPF from '../../components/Modal/Admin/PF/index';
import api from '../../services/api';

import {ToggleButton} from '../../components/ToggleButtom';

import './styles.css';

const ListProfiles = (props) => {

    const history = useHistory();

    const[adm] = useState(localStorage.getItem('adm'));

    const[showModalPJ, setShowModalPJ] = useState(false);
    const[showModalPF, setShowModalPF] = useState(false);

    const[users, setUsers] = useState([]);

    const[pages, setPages] = useState(null);
    const[currentPage, setCurrentPage] = useState(1);
    const[mount, setMount] = useState(false);

    const [search, setSearch] = useState('');

    const[b1, setB1] = useState(false);
    const[b2, setB2] = useState(true);
    const[b3, setB3] = useState(false);
    // const[b4, setB4] = useState(true)

    const[filter, setFilter] = useState(false);

    const [right, setRight] = useState('');

    const[disaleButton, setDisableButton] = useState(false);
    const[disablePagination, setDisablePagination] = useState(false);

    const[error, setError] = useState(false);
    const[load, setLoad] = useState(true);

    const joinFields  = useCallback(async (data) => {
        const profiles = [];

        for (let i = 0; i < data.users.length; i++) {
            const element = {...data.users[i], email:data.firebase[i], ...data.adress[i]};
            profiles.push(element);
        }

        setUsers(profiles);
    }, []);

    const joinFieldsDenunciantes = useCallback(async (data) => {
        const profiles = [];
        for (let i = 0; i < data.users.length; i++) {
            const element = {...data.users[i], email:data.firebase[i]};
            profiles.push(element);
        }
        setUsers(profiles);
    }, []);

    const API_PFandPJ = useCallback(async (type) =>{
        let option;
        if (filter) {
            option = 1;
        }else{
            option = 0;
        }
        await api.get(`/admin/list`, 
            {
                headers: {
                    authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,   
                    type:type,
                    page:currentPage,
                    filter: option,
                    // limit:15,
                }
            }
        ).then(response=>{
            //console.log(response, 'userList');
            setPages(response.data.pages);
            joinFields(response.data);
            setMount(true);
            setLoad(false);
            setTimeout(()=>setDisableButton(false), 3000);
            setTimeout(()=>setDisablePagination(false), 2000);
            
            // console.log(users)
        }).catch(() =>{
            setError(true);
            setDisableButton(false);
            setDisablePagination(false);
            props.firebase.auth.currentUser.getIdTokenResult()
                .then((idTokenResult) => {
                    localStorage.setItem('@Z52InSD4dnfjUDeVSEB0Byy',idTokenResult.token);
                    localStorage.setItem('VSEB0Byy',idTokenResult.claims.user_id);
                })
                .catch(( ) => {
                    //console.log(error);
                })
        })
    }, [currentPage, filter, joinFields, props.firebase.auth.currentUser]);

    const handleShowPF = useCallback(async () => {
        API_PFandPJ('user');//,9
    }, [API_PFandPJ]); 

    const handleShowPJ = useCallback(async () => {
        API_PFandPJ('legalEntity');
    }, [API_PFandPJ]);

    const handleShowOuvidorias = useCallback(async () => {
        API_PFandPJ('ouvidoria');
    }, [API_PFandPJ]);

    const handleChangeStatus = useCallback(async () => {
        setMount(false);
    }, []);

    // const handleShowAll = async() =>{

    //     await API_PFandPJ('user', 3, true)
    //     // console.log(array)
    //     await API_PFandPJ('legalEntity', 3, true)
    //     // console.log(array)
    //     await API_PFandPJ('ouvidoria', 3, true)
    //     console.log(array)

    // }

    const searchDiagnosis = useCallback(async (event) => {
        if (event !== undefined) {
            event.preventDefault();
        }
        setDisableButton(true);
        setDisablePagination(true);
        setLoad(true);
        if (search.length !== 0) {
            let option;
            if (filter) {
                option = 1;      
            }else{
                option = 0;      
            }
            if(b1){
                await api.get('/user/getByName', 
                { 
                    params: {
                        name: search, 
                        filter: option,
                        page:currentPage,
                    }
                },
                ).then( (response) =>{
                    console.log(response);
                    setPages(response.data.pages);
                    joinFieldsDenunciantes(response.data);
                    setTimeout(()=>setDisableButton(false), 3000);
                    setTimeout(()=>setDisablePagination(false), 2000);
                }).catch(( ) =>{
                    setTimeout(()=>setDisableButton(false), 3000);
                    setTimeout(()=>setDisablePagination(false), 2000);
                });
            }else if(b2){
                await api.get('/legalEntity/search', 
                    { 
                        params: {
                            name: search, 
                            filter: option,
                            page:currentPage,
                        }
                    },
                ).then( (response) =>{
                    setPages(response.data.pages);
                    joinFields(response.data);
                    setTimeout(()=>setDisableButton(false), 3000);
                    setTimeout(()=>setDisablePagination(false), 2000);
                }).catch(( ) => {
                    setTimeout(()=>setDisableButton(false), 3000);
                    setTimeout(()=>setDisablePagination(false), 2000);
                });


            }else if(b3){
                await api.get('/admin/getByName', 
                    { 
                        params: {
                            name: search, 
                            filter: option,
                        },
                        headers: {
                            authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,   
                            type:'',
                            page:currentPage,
                        }
                    }
                ).then( (response) =>{
                    setPages(response.data.pages);
                    joinFieldsDenunciantes(response.data);
                    setTimeout(()=>setDisableButton(false), 3000);
                    setTimeout(()=>setDisablePagination(false), 2000);
                }).catch(( ) =>{
                    setTimeout(()=>setDisableButton(false), 3000);
                    setTimeout(()=>setDisablePagination(false), 2000);
                });
            }
            setLoad(false);
        }else{
            setMount(false);
        }
    }, [b1, b2, b3, currentPage, filter, joinFields, joinFieldsDenunciantes, search]);

    useEffect(() => {
        if(!mount){
            if (search.length === 0) {
                if(b1){
                    setRight('Novos');
                    handleShowPF();
                }else if(b2){
                    setRight('Pendentes');
                    handleShowPJ();
                }else if(b3){
                    setRight('Novos');
                    handleShowOuvidorias();
                }
            }else{
                searchDiagnosis();
            }
        }
    }, [b1, b2, b3, handleShowOuvidorias, handleShowPF, handleShowPJ, mount, search, searchDiagnosis]);

    return(
        <AuthUserContext.Consumer> 
        {authUser =>
            authUser ? 
                <div>
                    <Header/>
                    <div className='container-management'>
                        <h1 className='page-title-adm'> Gestão de usuários</h1>
                        <div className='page-profiles-button'>
                            <ProfilesButton 
                                name='Denunciantes' 
                                type='Profile'
                                white={b1} 
                                
                                setB1={setB1} 
                                setB2={setB2} 
                                setB3={setB3} 
                                // setB4={setB4} 
                                
                                setMount={setMount} 
                                disable={disaleButton}
                                setDisabled={setDisableButton}
                                setCurrentPage={setCurrentPage}
                                setLoad={setLoad}
                            />
                            <ProfilesButton 
                                name='Denunciados' 
                                type='Profile'
                                white={b2} 
                                
                                setB1={setB1} 
                                setB2={setB2} 
                                setB3={setB3} 
                                // setB4={setB4} 
                                setMount={setMount} 
                                disable={disaleButton}
                                setDisabled={setDisableButton}
                                setCurrentPage={setCurrentPage}
                                setLoad={setLoad}
                            />
                            {adm === true || adm === 'true' ? 
                                <ProfilesButton 
                                    name='Ouvidorias' 
                                    type='Profile'
                                    white={b3} 
                                    
                                    setB1={setB1} 
                                    setB2={setB2} 
                                    setB3={setB3} 
                                    // setB4={setB4} 
                                    setMount={setMount} 
                                    disable={disaleButton}
                                    setDisabled={setDisableButton}
                                    setCurrentPage={setCurrentPage}
                                    setLoad={setLoad}
                                /> : null
                            }
                    
                        </div>
                        <div className='filter-styled'>
                            {filter ? 
                                <p className='filter-text-styled'>Todos</p> 
                                :
                                <p className='filter-text-styled-purple'>Todos</p>
                            }
                                <ToggleButton 
                                    setFilter={setFilter} 
                                    filter={filter}
                                    
                                    setMount={setMount} 
                                    disable={disaleButton}
                                    setDisabled={setDisableButton}
                                    setCurrentPage={setCurrentPage}
                                    setLoad={setLoad}
                                />
                            {filter ? 
                                <p className='filter-text-styled-purple'>{right}</p> 
                                :
                                <p className='filter-text-styled'>{right}</p>
                            }
                        </div>

                        <form onSubmit={searchDiagnosis} >
                            <div className='page-profiles-button'>
                                <button
                                    className='button-search-menu'
                                    type='submit'
                                    id ='pesquisar-button'  
                                    onClick={searchDiagnosis}
                                >
                                    <img 
                                        src={searchButton} 
                                        alt="search" 
                                    />
                                </button>

                                <TextField id="pesquisar-input" 
                                    label="Pesquisar"
                                    size = "small" 
                                    variant="outlined"
                                    className="search-input"
                                    error={error}
                                    value ={search} 
                                    onChange={ (event) => {
                                        setSearch(event.target.value);
                                        setError(false);
                                    }}
                                />

                            </div>
                        </form>
                        <div className = 'container-profile-cards'>
                            {
                                error ?
                                    <p className='progress-circle'>Erro na conexão com o servidor, recarrege a página</p>
                                :
                                    !load ?
                                        <>
                                        {
                                            users.length > 0 ? users.map( (item) => (
                                                <Card 
                                                    key={item._id} 
                                                    setShowPJ={setShowModalPJ}
                                                    setShowPF={setShowModalPF} 
                                                    data={item}
                                                    pj={b2}
                                                />
                                            ))
                                            :
                                            <p className='progress-circle'>Nenhum usuário encontrado.</p>
                                        }
                                        </>
                                        :
                                        
                                        <div className='progress-circle'>
                                            <CircularProgress color='primary' size={25} />
                                        </div>


                            }
                        </div>

                        <div>
                            <Pagination 
                                count={pages}
                                page={currentPage}
                                onChange={(event, value) => {
                                    console.log(value, 'paginationValue');
                                    value===currentPage ? setDisablePagination(false) : setDisablePagination(true)
                                    setCurrentPage(value)
                                    setMount(false)
                                }}
                                color='primary'
                                disabled={disablePagination}
                            />
                        </div>
                        
                    </div>
                    <ModalPJ show={showModalPJ} setShow={setShowModalPJ} changeStatus={handleChangeStatus}/>
                    <ModalPF show={showModalPF} setShow={setShowModalPF} changeStatus={handleChangeStatus} ouvidoria ={b3}/>

                </div>

        : 
            history.push('/')
        }
        </AuthUserContext.Consumer>
    )
}

const condition = authUser => !!authUser;

export default withAuthorization(condition)(ListProfiles);